<template>
    <div>
        <div v-if="!created">
            <h1 class="create-header">Idee erstellen</h1>
            <form
                class="create-form"
                action="create"
                method="post"
                enctype="multipart/form-data"
            >
                <label class="big-label">Titel*</label>
                <input class="input-text" placeholder="Titel" v-model="title" />
                <div class="horizontal-divider"></div>
                <label class="big-label">Kategorie*</label>

                <category-tabs
                    v-model="chosenCategories"
                    :categories="categories"
                ></category-tabs>
                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label"
                            ><img
                                src="/img/icons/creation/duration.svg"
                            />Dauer</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <creation-duration
                            @changeUnit="changeUnit"
                            v-model="duration"
                            :duration_unit="'0'"
                        ></creation-duration>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row creation-row-long">
                    <div class="creation-col-left">
                        <label class="big-label icon-label"
                            ><img
                                src="/img/icons/creation/preperation.svg"
                            />Vorbereitungszeit</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <creation-preperation
                            v-model="preperation"
                        ></creation-preperation>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label-2">
                            <img src="/img/icons/creation/age.svg" />
                            Altersklasse <br />(Jahre)</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <div class="slider-overlapper-l"></div>

                        <div class="slider-overlapper-r"></div>
                        <creation-age v-model="age"></creation-age>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label-2"
                            ><img
                                src="/img/icons/creation/age.svg"
                            />Anzahl<br />
                            Personen</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <creation-amount v-model="amount"></creation-amount>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label"
                            ><img
                                src="/img/icons/creation/price.svg"
                            />Kosten</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <creation-price v-model="price"></creation-price>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label"
                            ><img
                                src="/img/icons/creation/location.svg"
                            />Aufenthalt</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <creation-location
                            v-model="location"
                        ></creation-location>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label"
                            >Kaufen/Buchen</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <input class="input-text" v-model="buy_url" />
                    </div>
                </div>

                <div class="void-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label">Website</label>
                    </div>
                    <div class="creation-col-right">
                        <input class="input-text" v-model="website_url" />
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label"
                            >Beschreibung*</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <textarea
                            class="input-text text-area"
                            v-model="description"
                        />
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label">Materialien</label>
                    </div>
                    <div class="creation-col-right">
                        <creation-materials
                            v-model:material="material"
                        ></creation-materials>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label"
                            >Spiel-/<br />Programmziele</label
                        >
                    </div>
                    <div class="creation-col-right">
                        <creation-objectives
                            v-model:objective="objective"
                        ></creation-objectives>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row creation-row-image">
                    <div class="creation-col-left">
                        <label class="big-label icon-label">Bilder</label>
                    </div>
                    <div class="creation-col-right">
                        <creation-images v-model="images"></creation-images>
                    </div>
                    <!-- <div class="creation-col-right">
            <textarea class="input-text text-area" v-model="description" />
          </div> -->
                </div>

                <div class="horizontal-divider"></div>

                <div class="creation-row">
                    <div class="creation-col-left">
                        <label class="big-label icon-label">PDF</label>
                    </div>
                    <div class="creation-col-right">
                        <creation-pdf v-model="pdfs"></creation-pdf>
                    </div>
                </div>

                <div class="horizontal-divider"></div>

                <label class="big-label big-label-mb">Infrastruktur</label>
                <creation-infrastructure v-model="infrastructure" />

                <div class="horizontal-divider"></div>

                <div class="geolocation-time-wrapper">
                    <div class="g-map">
                        <google-maps
                            :neutral="neutral"
                            :lat="geolocation ? geolocation.latlng.lat : null"
                            :lng="geolocation ? geolocation.latlng.lng : null"
                            :disabled="noAddress"
                            :noClick="true"
                        >
                        </google-maps>
                    </div>
                    <div class="geolocation-time">
                        <div class="label-row">
                            <div class="big-label">Adresse</div>
                            <div class="disable-cb">
                                <v-checkbox
                                    v-model="noAddress"
                                    label="Keine Adresse"
                                    color="#33bbff"
                                    @change="togglenoAddress()"
                                    hide-details
                                ></v-checkbox>
                            </div>
                        </div>

                        <div class="geolocation-wrapper">
                            <div id="gp-w" class="geolocation-input">
                                <gmap-autocomplete
                                    @place_changed="gAdress"
                                />
                            </div>
                        </div>

                        <!-- <creation-geolocation
              :api-key="apiKey"
              :app-id="appId"
              :key="`${appId}-${apiKey}`"
              v-model="geolocation"
              :prefilled="null"
            /> -->
                        <div class="label-row label-row-time">
                            <div class="big-label">Zeit</div>
                            <div class="disable-cb">
                                <v-checkbox
                                    v-model="noTime"
                                    label="Keine Öffnungszeiten"
                                    color="#33bbff"
                                    hide-details
                                ></v-checkbox>
                            </div>
                        </div>
                        <textarea
                            :class="{ 'input-disabled': noTime }"
                            :disabled="noTime"
                            class="input-text text-area"
                            v-model="time"
                        />
                    </div>
                </div>

                <div class="horizontal-divider"></div>
                <div class="err-succ-messages">
                    <div
                        class="error-message"
                        v-for="errorMessage in errorMessages"
                        :key="errorMessage"
                    >
                        {{ errorMessage }}
                    </div>
                </div>
                <div class="save-wrapper">
                    <div class="agbcheck-wrapper">
                        <v-checkbox
                            v-model="agb"
                            label="Hiermit bestätige ich die Benutzerrichtlinien"
                            thumb-color="#33bbff"
                            color="#33bbff"
                            track-color="white"
                            track-fill-color="#33BBFF75"
                            value="2"
                            hide-details
                        ></v-checkbox>

                        <v-checkbox
                            v-if="images && images.length > 0"
                            v-model="rights"
                            label="Ich bin Rechteinhaber der hochgeladenen Bilder/ diese Bilder sind lizenzfrei benutzbar."
                            thumb-color="#33bbff"
                            color="#33bbff"
                            track-color="white"
                            track-fill-color="#33BBFF75"
                            value="2"
                            hide-details
                        ></v-checkbox>
                    </div>
                    <button
                        @click.prevent="createIdea()"
                        class="btn btn-blue create-btn"
                        href="#"
                    >
                        <img src="/img/icons/save.svg" />Speichern
                    </button>
                </div>
            </form>
        </div>
        <div v-if="created" class="creation-success">
            <img src="/img/success.svg" />
            <h1>Deine Idee wurde erstellt</h1>
            <p>
                Wir haben deine Idee an einen Administrator weitergeleitet.
                Diese wird geprüft und dann freigeschaltet. Wir informieren dich
                per E-Mail wenn es soweit ist.
            </p>
            <div class="btn-row">
                <a href="/" class="btn btn-white"> Zurück zur Startseite </a>
                <button @click="created = false" class="btn btn-blue" href="#">
                    Neue Idee erstellen
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["categories"],
    data() {
        return {
            appId: "plA1E1SCQOJJ",
            apiKey: "3bc0540d1aa0afafa8f07124134257f3",
            geolocation: null,
            noAddress: true,
            noTime: true,
            neutral: true,
            time: "",
            errorMessages: [],
            title: "",
            description: "",
            material: "",
            objective: "",
            buy_url: "",
            website_url: "",
            age: [5, 10],
            preperation: false,
            chosenCategories: {},
            duration: null,
            duration_unit: "0",
            amount: null,
            price: 0,
            location: {
                indoor: 0,
                outdoor: 0
            },
            infrastructure: {
                wheelchair: 0,
                stroller: 0,
                transportation: 0,
                parking: 0,
                dogs: 0,
                drinking: 0,
                firepit: 0,
                picnic: 0,
                playground: 0,
                restaurant: 0,
                toilet: 0
            },
            created: false,
            images: null,
            pdfs: null,
            agb: false,
            rights: false,
            gMapAuto: {}
        };
    },
    methods: {
        gAdress(e) {
            let postal_code = null;
            let street = null;
            let number = "";
            let city = null;
            for (var i = 0; i < e.address_components.length; i++) {
                for (var j = 0; j < e.address_components[i].types.length; j++) {
                    if (e.address_components[i].types[j] == "postal_code") {
                        postal_code = e.address_components[i].long_name;
                    }

                    if (e.address_components[i].types[j] == "route") {
                        street = e.address_components[i].long_name;
                    }

                    if (e.address_components[i].types[j] == "street_number") {
                        number = e.address_components[i].long_name ?? " ";
                    }

                    if (e.address_components[i].types[j] == "locality") {
                        city = e.address_components[i].long_name;
                    }
                }
            }
            console.log("postal_code", postal_code);
            let tmpGeo = {
                latlng: {
                    lat: e.geometry.location.lat(),
                    lng: e.geometry.location.lng()
                },
                name: e.name,
                street: street + " " + number,
                zip: postal_code,
                city: city
            };

            this.geolocation = tmpGeo;
        },
        changeUnit(val) {
            // console.log("1 is hour", val);
            if (val === "1") {
                if (Array.isArray(this.duration)) {
                    this.duration = [1, 4];
                } else {
                    this.duration = 3;
                }
            } else {
                if (Array.isArray(this.duration)) {
                    this.duration = [
                        Math.floor(this.duration[0]),
                        Math.floor(this.duration[1])
                    ];
                } else {
                    this.duration = Math.floor(this.duration);
                }
            }

            this.duration_unit = val;
        },
        togglenoAddress() {
            this.neutral = this.noAddress;
            if (this.noAddress) {
                document
                    .querySelector(".ap-input")
                    .classList.add("input-disabled");
                document.querySelector(".ap-input").disabled = true;
            } else {
                document
                    .querySelector(".ap-input")
                    .classList.remove("input-disabled");
                document.querySelector(".ap-input").disabled = false;
            }
        },

        async createIdea() {
            this.errorMessages = [];
            if (!this.chosenCategories.valid) {
                this.errorMessages.push(
                    "Bitte wähle die spezifischste Kategorie."
                );
            }

            if (!this.agb) {
                this.errorMessages.push(
                    "Bitte akzeptiere die Benutzerrichtlinien."
                );
            }
            if (this.images && this.images.length > 0 && !this.rights) {
                this.errorMessages.push(
                    "Bitte bestätige dass du die Rechte an den Bildern hälst."
                );
            }

            if (this.errorMessages.length > 0) {
                return;
            }
            //some tweaks because ranges gives us an array while fixed value is just an array -> backend always awaits array
            let durationTmp = this.sanitizeDuration();
            let amountTmp = this.sanitizeAmount();
            let priceTmp = this.sanitziePrice();
            let timeTmp = this.sanitizeTime();
            let geolocationTmp = this.sanitizeGeolocation();

            let payload = {
                categories: {
                    main: this.chosenCategories.main.id ?? null,
                    sub: this.chosenCategories.sub.id ?? null,
                    subsub: this.chosenCategories.subsub.id ?? null
                },
                age: this.age,
                preperation: this.preperation,
                duration: durationTmp,
                amount: amountTmp,
                price: priceTmp,
                location: this.location,
                title: this.title,
                buy_url: this.buy_url,
                website_url: this.website_url,
                description: this.description,
                material: this.material,
                objective: this.objective,
                infrastructure: this.infrastructure,
                time: timeTmp,
                geolocation: geolocationTmp,
                images: this.images,
                pdfs: this.pdfs || [],
                duration_unit: this.duration_unit === "1" ? 1 : 0
            };
            console.log("payload is this", payload);

            const formData = new FormData();
            formData.append(
                "categories",
                payload.categories ? JSON.stringify(payload.categories) : null
            );
            formData.append("age", payload.age);
            formData.append("preperation", payload.preperation);
            formData.append("duration", payload.duration);
            formData.append("amount", payload.amount);
            formData.append("price", payload.price);
            formData.append(
                "location",
                payload.location ? JSON.stringify(payload.location) : null
            );
            formData.append("title", payload.title);
            formData.append("buy_url", payload.buy_url);
            formData.append("website_url", payload.website_url);
            formData.append("description", payload.description);
            formData.append("material", payload.material);
            formData.append("objective", payload.objective);
            formData.append(
                "infrastructure",
                payload.infrastructure
                    ? JSON.stringify(payload.infrastructure)
                    : null
            );
            formData.append("time", payload.time);
            formData.append(
                "geolocation",
                payload.geolocation ? JSON.stringify(payload.geolocation) : null
            );
            formData.append(
                "images",
                payload.images ? JSON.stringify(payload.images) : null
            );
            formData.append(
                "pdf1",
                payload.pdfs[0] !== undefined ? payload.pdfs[0] : null
            );
            formData.append(
                "pdf2",
                payload.pdfs[1] !== undefined ? payload.pdfs[1] : null
            );
            formData.append(
                "pdf3",
                payload.pdfs[2] !== undefined ? payload.pdfs[2] : null
            );
            formData.append("duration_unit", payload.duration_unit);
            console.log("formData is this", formData);

            axios
                .post("/ideas", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(res => {
                    if (res.status == 201) {
                        // IDEA CREATED, RESET INPUT FIELDS
                        this.clearInputs();

                        this.created = true;
                        document
                            .querySelector("main")
                            .scrollIntoView({ behavior: "smooth" });
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        for (const [key, value] of Object.entries(
                            error.response.data.errors
                        )) {
                            this.errorMessages.push(value[0]);
                        }
                    }
                    console.log(error.response.data);
                });
        },

        sanitizeDuration() {
            //console.log(typeof this.duration === "number", this.duration_unit)
            if (typeof this.duration === "number") {
                if (this.duration_unit === "1") {
                    return [this.duration * 60];
                }
                return [this.duration];
            }
            if (this.duration_unit === "1") {
                let tmp = [];
                tmp[0] = this.duration[0] * 60;
                tmp[1] = this.duration[1] * 60;
                return tmp;
            }
            return this.duration;
        },
        sanitizeAmount() {
            if (typeof this.amount === "number") {
                return [this.amount];
            }
            return this.amount;
        },
        sanitziePrice() {
            if (typeof this.price === "number") {
                return [this.price];
            }
            return this.price;
        },
        sanitizeTime() {
            if (this.noTime) {
                return "";
            }
            return this.time;
        },
        sanitizeGeolocation() {
            if (this.noAddress) {
                return null;
            }
            return this.geolocation;
        },

        clearInputs() {
            this.title = "";
            this.description = "";
            this.materials = "";
            this.objective = "";
            this.buy_url = "";
            this.website_url = "";
            this.age = [5, 10];
            this.preperation = "0";
            this.chosenCategories = {};
            this.duration = null;
            this.pdfs = null;
            this.price = null;
            this.location = {
                indoor: 0,
                outdoor: 0
            };
            this.infrastructure = {
                wheelchair: 0,
                stroller: 0,
                transportation: 0,
                parking: 0,
                dogs: 0,
                drinking: 0,
                firepit: 0,
                picnic: 0,
                playground: 0,
                restaurant: 0,
                toilet: 0
            };
        }
    },

    mounted() {
        document.getElementById("gp-w").children[0].classList.add("ap-input");
        document.querySelector(".ap-input").classList.add("input-disabled");
        document.querySelector(".ap-input").disabled = true;
    },
    computed: {},
    watch: {
        geolocation(newVal) {
            this.neutral = false;
        }
    }
};
</script>

<style></style>
